import { action } from 'satcheljs';
import { ReplyWithAttachmentSuggestion } from '../store/schema/AttachmentSuggestions';

export const getContextualMRUSuggestionsAction = action(
    'getContextualMRUSuggestionsAction',
    (referenceItemId: string) => ({
        referenceItemId,
    })
);

/**
 * Makes a service call to the MRU attachment service.
 * for classic and cloudy attachments.
 */
export const getMRUSuggestionsAction = action('getMRUSuggestionsAction');

export const storeContextualMRUSuggestionsOnItemAction = action(
    'storeContextualMRUSuggestionsOnItemAction',
    (
        referenceItemId: string,
        contextualSuggestions: ReplyWithAttachmentSuggestion[],
        traceId: string
    ) => ({
        referenceItemId,
        contextualSuggestions,
        traceId,
    })
);

export const storeMRUSuggestionsAction = action(
    'storeMRUSuggestionsAction',
    function storeMRUSuggestionsAction(
        mruAttachments: ReplyWithAttachmentSuggestion[],
        traceId: string
    ) {
        return {
            mruAttachments,
            traceId,
        };
    }
);
